import React, { createContext } from "react";

const ScreenshotContext = createContext();

export const ScreenshotContextProvider = ({ children, screenshotStyle }) => {
  return (
    <ScreenshotContext.Provider value={screenshotStyle}>
      {children}
    </ScreenshotContext.Provider>
  );
};

export const useScreenshotContext = () => {
  const context = React.useContext(ScreenshotContext);

  return context;
};
